







































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mdiPlay } from '@mdi/js'
import { IVideoItem } from '~/assets/interfaces/video'
import MixinGeneral from '~/assets/mixins/general'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
    ComponentIcon,
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentVideo: () => import('~/components/video/video.vue'),
  },
})
export default class ComponentVideoItem extends mixins(MixinGeneral) {
  @Prop({ type: Object, default: () => {} }) readonly item!: IVideoItem

  private mdiPlay = mdiPlay
  private isShowVideo = false
}
